import { render, staticRenderFns } from "./card-feature.vue?vue&type=template&id=78dd1465&"
import script from "./card-feature.vue?vue&type=script&lang=js&"
export * from "./card-feature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports